export type ChangeLogEntry = {
  date: string;
  title: string;
  changes: string[];
};

export const CHANGE_LOG_ENTRIES: ChangeLogEntry[] = [
  {
    date: '7.7.2026',
    title: 'Externí data, odečty a přehlednější práce s vyúčtováním',
    changes: [
      'Přidáno napojení na EG.D pro automatické načítání externích spotřebních dat',
      'Přidána upozornění na chybějící odečty spotřeby s možností přejít rovnou k nahrání odečtu',
      'U spotřeb je nově vidět, zda pochází z vyúčtování nebo z ručního nahrání',
      'Do vyúčtování a odběrných míst byly doplněny informace o dodavateli včetně historie dodavatelů',
      'Dashboard a grafy skupin objektů byly upraveny pro přehlednější porovnání dat',
    ]
  },
  {
    date: '24.6.2026',
    title: 'Grafy, importy a návaznost měření',
    changes: [
      'Přidány nové typy grafů v detailu objektů i jejich skupin',
      'Výrazně rozšířen hromadný import faktur včetně lepší podpory automatického zakládání odběrných míst',
      'Doplněna podpora výměny měřidel a návaznosti dat, aby spotřeby a grafy plynule pokračovaly i po změně měřidla',
      'Přidána upozornění na inspekce a revize objektů s možností jejich přehlednější správy',
      'Do detailu objektu byla přidána možnost vyplnit kartu budovy'
    ]
  },
  {
    date: '18.5.2026',
    title: 'Dashboard, měření a správa účtů',
    changes: [
      'Dashboard byl rozšířen o nové grafy a porovnání spotřeby, komodit i emisí',
      'Vylepšen vzhled dashboardu včetně ikon a přehlednosti karet',
      'Při ověření účtu administrátorem se nyní automaticky odesílá potvrzovací e-mail',
      'Vylepšené čtení dat z faktur Pražské plynárenské'
    ]
  },
  {
    date: '11.5.2026',
    title: 'Levý panel a faktury za plyn',
    changes: [
      'Levý panel je nyní možné skrýt a znovu zobrazit pomocí tlačítka v pravém horním rohu',
      'Došlo ke zlepšení čtení dat z faktur za plyn'
    ]
  },
  {
    date: '26.4.2026',
    title: 'Předplatné a platby',
    changes: [
      'Integrace předplatného do aplikace',
      'Napojení platební brány pro online platby',
      'Přidány platební routy pro správu plateb',
      'Přidán ceník tarifů'
    ]
  },
  {
    date: '12.4.2026',
    title: 'Nový dashboard a přehledy',
    changes: [
      'Nasazen nový dashboard',
      'Přidán sdílený graf podporující více vstupů',
      'Rozšířeno hromadné nahrávání více faktur najednou'
    ]
  },
  {
    date: '5.4.2026',
    title: 'Modul inspekcí',
    changes: ['Přidán nový modul inspekcí']
  },
  {
    date: '31.3.2026',
    title: 'Práce s fakturami',
    changes: ['Možnost znovu použít již zpracovanou fakturu']
  },
  {
    date: '7.3.2026',
    title: 'Správa skupin objektů',
    changes: [
      'Přidáno řazení skupin objektů',
      'Přidána možnost přidávat záznamy skupin i při editaci'
    ]
  },
  {
    date: '3.3.2026',
    title: 'Správa uživatelských účtů',
    changes: [
      'Možnost resetu e-mailu uživatele',
      'Možnost znovu odeslat ověřovací e-mail'
    ]
  },
  {
    date: '26.2.2026',
    title: 'Aktualizace systému',
    changes: [
      'Podpora seskupení objektů',
      'Možnost nastavení přístupu uživatelů na úrovni objektů',
      'Opraveny menší chyby a zlepšena stabilita aplikace.'
    ]
  },
  {
    date: '20.2.2026',
    title: 'Aktualizace systému',
    changes: ['Možnost přístupu do více obcí pod jedním účtem']
  }
];
